// Mock data for the admin dashboard.
// Replace these with API responses when the backend endpoints are ready.

export const BRAND = {
  red: "#EA352B",
  redSoft: "#FDECEA",
  orange: "#FF8A3D",
  amber: "#F5B400",
  dark: "#1B1B22",
  green: "#16A34A",
  blue: "#2563EB",
  muted: "#8A8F98",
};

// Customers may add up to this many vehicles for free; beyond it they must subscribe.
export const FREE_VEHICLE_LIMIT = 2;

export const kpis = [
  { key: "customers", to: "/user-management/customer", label: "Total Customers", value: "12,340", change: 12.4, spark: [30, 42, 38, 51, 49, 60, 72] },
  { key: "providers", to: "/user-management/service-provider", label: "Service Providers", value: "1,240", change: 6.1, spark: [20, 22, 25, 24, 29, 31, 34] },
  { key: "shops", to: "/user-management/service-provider", label: "Active Shops", value: "986", change: 4.8, spark: [14, 18, 17, 21, 24, 23, 27] },
  { key: "vehicles", label: "Registered Vehicles", value: "21,870", change: 9.3, spark: [40, 45, 50, 48, 58, 63, 70] },
  { key: "subscribers", label: "Active Subscribers", value: "2,145", change: 18.2, spark: [10, 14, 19, 22, 27, 33, 41] },
  { key: "revenue", label: "Total Revenue", value: "AED 184.3K", change: -2.1, spark: [50, 46, 52, 44, 47, 43, 45] },
];

export const revenueByPeriod = {
  "7D": [
    { name: "Mon", services: 4200, subscriptions: 1100 },
    { name: "Tue", services: 5100, subscriptions: 1250 },
    { name: "Wed", services: 3900, subscriptions: 1300 },
    { name: "Thu", services: 6200, subscriptions: 1420 },
    { name: "Fri", services: 7400, subscriptions: 1500 },
    { name: "Sat", services: 8900, subscriptions: 1680 },
    { name: "Sun", services: 6100, subscriptions: 1720 },
  ],
  "30D": [
    { name: "Week 1", services: 28400, subscriptions: 7400 },
    { name: "Week 2", services: 31200, subscriptions: 8100 },
    { name: "Week 3", services: 29800, subscriptions: 8900 },
    { name: "Week 4", services: 36500, subscriptions: 9600 },
  ],
  "12M": [
    { name: "Oct", services: 82000, subscriptions: 14000 },
    { name: "Nov", services: 91000, subscriptions: 16500 },
    { name: "Dec", services: 104000, subscriptions: 19000 },
    { name: "Jan", services: 97000, subscriptions: 21000 },
    { name: "Feb", services: 99000, subscriptions: 22800 },
    { name: "Mar", services: 112000, subscriptions: 24500 },
    { name: "Apr", services: 118000, subscriptions: 26000 },
    { name: "May", services: 121000, subscriptions: 27900 },
    { name: "Jun", services: 116000, subscriptions: 29400 },
    { name: "Jul", services: 128000, subscriptions: 31200 },
    { name: "Aug", services: 134000, subscriptions: 33800 },
    { name: "Sep", services: 141000, subscriptions: 36100 },
  ],
  // All time, grouped by quarter since launch
  All: [
    { name: "Q1 '24", services: 38000, subscriptions: 0 },
    { name: "Q2 '24", services: 61000, subscriptions: 0 },
    { name: "Q3 '24", services: 94000, subscriptions: 4200 },
    { name: "Q4 '24", services: 132000, subscriptions: 11800 },
    { name: "Q1 '25", services: 168000, subscriptions: 19600 },
    { name: "Q2 '25", services: 201000, subscriptions: 28400 },
    { name: "Q3 '25", services: 236000, subscriptions: 36900 },
    { name: "Q4 '25", services: 277000, subscriptions: 49500 },
    { name: "Q1 '26", services: 308000, subscriptions: 68300 },
    { name: "Q2 '26", services: 355000, subscriptions: 83400 },
    { name: "Q3 '26", services: 403000, subscriptions: 101100 },
  ],
};

// Revenue period meta: label shown in the UI and the total of the previous
// equivalent period (used for the % change). All time has nothing to compare against.
export const revenuePeriodMeta = {
  "7D": { label: "Last 7 days", unit: "day", previousTotal: 50120 },
  "30D": { label: "Last 30 days", unit: "week", previousTotal: 146300 },
  "12M": { label: "Last 12 months", unit: "month", previousTotal: 1391000 },
  All: { label: "Since launch (Jan 2024)", unit: "quarter", previousTotal: null },
};

export const subscriptionSummary = {
  mrr: "AED 36,100",
  conversionRate: 17.4,
  churnRate: 2.3,
  split: [
    { name: "Subscribed", value: 2145, color: BRAND.red },
    { name: "Free (≤ 2 vehicles)", value: 10195, color: "#E9E9EE" },
  ],
  plans: [
    { name: "Monthly", subscribers: 1380, price: "AED 29 / mo", color: BRAND.red },
    { name: "Quarterly", subscribers: 455, price: "AED 79 / qtr", color: BRAND.orange },
    { name: "Yearly", subscribers: 310, price: "AED 279 / yr", color: BRAND.amber },
  ],
};

// How many customers own N vehicles
export const vehiclesPerCustomer = [
  { name: "1", customers: 6420 },
  { name: "2", customers: 3775 },
  { name: "3", customers: 1310 },
  { name: "4", customers: 520 },
  { name: "5+", customers: 315 },
];

// Same list the customer picks from in the app (AddNewCarScreen → VEHICLE_TYPES)
export const vehicleTypes = [
  { name: "Sedan", count: 7420, color: BRAND.red },
  { name: "SUV", count: 5980, color: BRAND.orange },
  { name: "Crossover", count: 2860, color: BRAND.amber },
  { name: "Hatchback", count: 1940, color: BRAND.dark },
  { name: "Truck", count: 1310, color: "#4B5563" },
  { name: "Coupe", count: 820, color: "#6B7280" },
  { name: "Minivan", count: 760, color: "#9CA3AF" },
  { name: "Station Wagon", count: 470, color: "#B8BCC6" },
  { name: "Microcar", count: 310, color: "#D1D5DB" },
]

export const userGrowth = [
  { name: "Apr", customers: 820, providers: 64 },
  { name: "May", customers: 940, providers: 71 },
  { name: "Jun", customers: 880, providers: 58 },
  { name: "Jul", customers: 1120, providers: 83 },
  { name: "Aug", customers: 1260, providers: 92 },
  { name: "Sep", customers: 1410, providers: 105 },
];

export const serviceCategories = [
  { name: "Oil Change", jobs: 1799, color: BRAND.red },
  { name: "Car Wash", jobs: 1649, color: BRAND.orange },
  { name: "Tyres", jobs: 1280, color: BRAND.amber },
  { name: "Repair", jobs: 649, color: BRAND.dark },
  { name: "Battery", jobs: 412, color: "#6B7280" },
  { name: "Fuel Delivery", jobs: 298, color: "#B8BCC6" },
];

// Shops use the same shape the provider app sends to /api/shop/addShop
// (CreateShopScreen → ProviderServiceScreen):
//   shopName, shopImage, locations[], workingHours[], services[], socialLinks[]
// Only days the provider switched on are sent in workingHours; 24-hour days
// are sent as 00:00 – 23:59. Each service's `serviceName` is its category.
// `provider`, `jobs`, `rating`, `revenue`, `status` are admin-side stats.
const hours = (days, startTime, endTime) =>
  days.map((day) => ({ day, startTime, endTime, isOpen: true }));
const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

export const topShops = [
  {
    _id: "shop_01",
    shopName: "Speedy Motors",
    shopImage: "",
    provider: { name: "Ahmed Khan", phone: "+971 50 555 0101", email: "ahmed@speedymotors.ae" },
    createdAt: "12 Mar 2024",
    locations: [{ title: "Primary Location", latitude: 25.0805, longitude: 55.1403, address: "Shop 4, Marina Plaza, Dubai Marina, Dubai", isPrimary: true }],
    workingHours: [...hours(WEEKDAYS, "08:00", "21:00"), ...hours(["Saturday"], "09:00", "18:00")],
    services: [
      { title: "Mobil 1 5W-30 Full Synthetic", serviceName: "Oil Change", description: "Engine oil + OEM filter replacement, up to 5L.", serviceImage: "", isAvailable: true },
      { title: "Castrol EDGE 0W-20", serviceName: "Oil Change", description: "Premium synthetic oil for hybrids and new models.", serviceImage: "", isAvailable: true },
      { title: "Shell Helix HX7 10W-40", serviceName: "Oil Change", description: "Semi-synthetic, budget friendly.", serviceImage: "", isAvailable: false },
      { title: "Brake pads (front)", serviceName: "Repair", description: "Brembo / OEM pads, labour included.", serviceImage: "", isAvailable: true },
      { title: "AC gas refill", serviceName: "AC Service", description: "R134a / R1234yf refill with leak test.", serviceImage: "", isAvailable: true },
    ],
    socialLinks: [
      { type: "website", title: "Website", url: "www.speedymotors.ae" },
      { type: "instagram", title: "Instagram", url: "@speedymotors.dxb" },
      { type: "whatsapp", title: "WhatsApp", url: "+971505550101" },
    ],
    jobs: 209, rating: 4.9, revenue: "AED 24,180", status: "Active",
  },
  {
    _id: "shop_02",
    shopName: "AutoFix Ltd",
    shopImage: "",
    provider: { name: "Rashid Ali", phone: "+971 55 555 0202", email: "rashid@autofix.ae" },
    createdAt: "02 May 2024",
    locations: [{ title: "Primary Location", latitude: 25.1372, longitude: 55.2296, address: "Street 8, Al Quoz Industrial Area 3, Dubai", isPrimary: true }],
    workingHours: hours([...WEEKDAYS, "Saturday"], "07:30", "20:00"),
    services: [
      { title: "Brake pads & discs", serviceName: "Repair", description: "Front or rear axle, Brembo parts available.", serviceImage: "", isAvailable: true },
      { title: "Suspension check", serviceName: "Repair", description: "Shock absorbers, bushes, alignment check.", serviceImage: "", isAvailable: true },
      { title: "Full diagnostics", serviceName: "Diagnostics", description: "OBD scan with printed report.", serviceImage: "", isAvailable: true },
    ],
    socialLinks: [
      { type: "facebook", title: "Facebook", url: "https://facebook.com/autofixltd" },
      { type: "email", title: "email", url: "service@autofix.ae" },
    ],
    jobs: 176, rating: 4.8, revenue: "AED 19,640", status: "Active",
  },
  {
    _id: "shop_03",
    shopName: "Sparkle Car Wash",
    shopImage: "",
    provider: { name: "Maria Lopez", phone: "+971 52 555 0303", email: "maria@sparkle.ae" },
    createdAt: "18 Aug 2024",
    locations: [{ title: "Primary Location", latitude: 25.0693, longitude: 55.1413, address: "Cluster D, Jumeirah Lake Towers, Dubai", isPrimary: true }],
    workingHours: hours(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"], "00:00", "23:59"),
    services: [
      { title: "Exterior wash", serviceName: "Car Wash", description: "Foam wash, rinse and hand dry.", serviceImage: "", isAvailable: true },
      { title: "Full wash (interior + exterior)", serviceName: "Car Wash", description: "Vacuum, dashboard polish, windows.", serviceImage: "", isAvailable: true },
      { title: "Wax polish", serviceName: "Detailing", description: "Carnauba wax, 2-hour job.", serviceImage: "", isAvailable: true },
    ],
    socialLinks: [
      { type: "instagram", title: "Instagram", url: "@sparkle.carwash" },
      { type: "whatsapp", title: "WhatsApp", url: "+971525550303" },
    ],
    jobs: 162, rating: 4.7, revenue: "AED 11,320", status: "Active",
  },
  {
    _id: "shop_04",
    shopName: "Tyre Hub",
    shopImage: "",
    provider: { name: "Omar Farooq", phone: "+971 56 555 0404", email: "omar@tyrehub.ae" },
    createdAt: "30 Sep 2024",
    locations: [{ title: "Primary Location", latitude: 25.2711, longitude: 55.3075, address: "Al Maktoum Rd, Deira, Dubai", isPrimary: true }],
    workingHours: [...hours(WEEKDAYS, "09:00", "22:00"), ...hours(["Sunday"], "12:00", "20:00")],
    services: [
      { title: "Tyre rotation + balancing", serviceName: "Tyres", description: "All four wheels, weights included.", serviceImage: "", isAvailable: true },
      { title: "Michelin Primacy 4", serviceName: "Tyres", description: "Sizes 16\"–20\", fitting included.", serviceImage: "", isAvailable: true },
      { title: "Puncture repair", serviceName: "Tyres", description: "Plug or patch, same day.", serviceImage: "", isAvailable: true },
    ],
    socialLinks: [{ type: "website", title: "Website", url: "tyrehub.ae" }],
    jobs: 131, rating: 4.6, revenue: "AED 14,050", status: "Busy",
  },
  {
    _id: "shop_05",
    shopName: "Mike Auto Care",
    shopImage: "",
    provider: { name: "Mike Brown", phone: "+971 58 555 0505", email: "mike@mikeauto.ae" },
    createdAt: "07 Jan 2025",
    locations: [{ title: "Primary Location", latitude: 25.3463, longitude: 55.4209, address: "Industrial Area 6, Sharjah", isPrimary: true }],
    workingHours: hours(["Monday", "Tuesday", "Wednesday", "Thursday", "Saturday"], "08:00", "19:00"),
    services: [
      { title: "Varta battery replacement", serviceName: "Battery", description: "60–95Ah, home service available.", serviceImage: "", isAvailable: true },
      { title: "Battery health test", serviceName: "Battery", description: "Free with any service.", serviceImage: "", isAvailable: true },
      { title: "Mobil 1 5W-30", serviceName: "Oil Change", description: "Oil + filter.", serviceImage: "", isAvailable: true },
    ],
    socialLinks: [],
    jobs: 118, rating: 4.5, revenue: "AED 12,760", status: "Active",
  },
];

// Bookings start as a chat: the customer opens a chat request (Pending),
// the provider accepts it and they chat (In Chat), then the provider marks it
// Completed once the job is done, or Rejects the request.
// `visits` = how many times this customer has booked with this shop.
export const BOOKING_STATUSES = ["Pending", "In Chat", "Completed", "Rejected"];

export const bookingStatusCounts = {
  Pending: 86,
  "In Chat": 142,
  Completed: 5680,
  Rejected: 214,
};

// Each booking is a chat. When the customer creates it, the app sends their
// details, the car, the selected service and the options they picked inside
// that service (e.g. Oil Change → oil brand). The chat stays locked until the
// provider accepts it.
//   customer  – who booked, and `visits` = times they've booked with this shop
//   car       – the vehicle picked from the customer's garage. Field names match
//               the mobile app's CreateVechile payload (AddNewCarScreen), so the
//               backend vehicle object can be passed through as-is. fuelType is
//               stored as a sourceId in the app — the API should return its name.
//   service   – category + the options chosen inside it
//   timeline  – status history (created → accepted → completed / rejected)
//   chat      – messages; `from` is "customer" | "provider" | "system"
export const recentBookings = [
  {
    id: "#CH-4521",
    status: "Completed",
    updated: "5 min ago",
    shop: "Speedy Motors",
    provider: "Ahmed Khan",
    visits: 5,
    customer: { name: "Sarah Khan", phone: "+971 50 123 4567", email: "sarah.khan@mail.com", memberSince: "Mar 2024", subscribed: true },
    car: { vehicleType: "Sedan", vehicleYear: 2021, vehicleMake: "Toyota", vehicleModel: "Camry", vehicleIdentificaionNumber: "4T1B11HK5MU123456", fuelType: "Special 95", currentOdometerReading: 42300, plateSource: "Dubai", plateCategory: "Private", plateCode: "A", plate: "48213" },
    service: {
      category: "Oil Change",
      options: [
        { label: "Oil brand", value: "Mobil 1" },
        { label: "Oil grade", value: "5W-30 Full Synthetic" },
        { label: "Oil filter", value: "Replace (OEM)" },
        { label: "Service type", value: "Visit shop" },
      ],
      preferredTime: "Today, 4:00 PM",
      notes: "Please also check the tyre pressure.",
      estimate: "AED 180",
    },
    timeline: [
      { status: "Chat created", time: "Today, 1:12 PM" },
      { status: "Accepted by provider", time: "Today, 1:20 PM" },
      { status: "Marked completed", time: "Today, 5:05 PM" },
    ],
    chat: [
      { from: "system", text: "Booking request sent — chat is locked until the provider accepts.", time: "1:12 PM" },
      { from: "system", text: "Speedy Motors accepted the request. Chat unlocked.", time: "1:20 PM" },
      { from: "provider", text: "Hi Sarah! We have Mobil 1 5W-30 in stock. 4 PM works for us.", time: "1:21 PM" },
      { from: "customer", text: "Great, see you at 4. Can you check the tyres too?", time: "1:24 PM" },
      { from: "provider", text: "Sure, no extra charge for the pressure check 👍", time: "1:25 PM" },
      { from: "provider", text: "All done — oil and filter replaced, tyres set to 35 PSI.", time: "5:03 PM" },
      { from: "system", text: "Provider marked this booking as completed.", time: "5:05 PM" },
    ],
  },
  {
    id: "#CH-4520",
    status: "In Chat",
    updated: "12 min ago",
    shop: "Tyre Hub",
    provider: "Omar Farooq",
    visits: 2,
    customer: { name: "John Doe", phone: "+971 55 987 6543", email: "john.doe@mail.com", memberSince: "Jan 2025", subscribed: false },
    car: { vehicleType: "SUV", vehicleYear: 2019, vehicleMake: "Nissan", vehicleModel: "Patrol", vehicleIdentificaionNumber: "JN8AY2NY9K9012345", fuelType: "Super 98", currentOdometerReading: 88900, plateSource: "Abu Dhabi", plateCategory: "Private", plateCode: "12", plate: "77410" },
    service: {
      category: "Tyres",
      options: [
        { label: "Job", value: "Tyre rotation + balancing" },
        { label: "Tyre brand", value: "Michelin" },
        { label: "Tyre size", value: "275/60 R20" },
        { label: "Service type", value: "Visit shop" },
      ],
      preferredTime: "Tomorrow, 10:00 AM",
      notes: "",
      estimate: "AED 120",
    },
    timeline: [
      { status: "Chat created", time: "Today, 2:40 PM" },
      { status: "Accepted by provider", time: "Today, 2:55 PM" },
    ],
    chat: [
      { from: "system", text: "Booking request sent — chat is locked until the provider accepts.", time: "2:40 PM" },
      { from: "system", text: "Tyre Hub accepted the request. Chat unlocked.", time: "2:55 PM" },
      { from: "provider", text: "Hello John, 10 AM tomorrow is confirmed.", time: "2:56 PM" },
      { from: "customer", text: "Perfect. How long will it take?", time: "3:01 PM" },
      { from: "provider", text: "Around 45 minutes.", time: "3:02 PM" },
    ],
  },
  {
    id: "#CH-4519",
    status: "Pending",
    updated: "20 min ago",
    shop: "Sparkle Car Wash",
    provider: "Maria Lopez",
    visits: 1,
    customer: { name: "Fatima Noor", phone: "+971 52 456 7788", email: "fatima.noor@mail.com", memberSince: "Sep 2026", subscribed: false },
    car: { vehicleType: "Sedan", vehicleYear: 2022, vehicleMake: "Honda", vehicleModel: "Civic", vehicleIdentificaionNumber: "2HGFE2F59NH543210", fuelType: "Special 95", currentOdometerReading: 18450, plateSource: "Sharjah", plateCategory: "Private", plateCode: "3", plate: "20981" },
    service: {
      category: "Car Wash",
      options: [
        { label: "Package", value: "Full wash (interior + exterior)" },
        { label: "Add-on", value: "Wax polish" },
        { label: "Service type", value: "Home service" },
      ],
      preferredTime: "Today, 6:30 PM",
      notes: "Parking B2, slot 114.",
      estimate: "AED 75",
    },
    timeline: [{ status: "Chat created", time: "Today, 3:30 PM" }],
    chat: [
      { from: "system", text: "Booking request sent — chat is locked until the provider accepts.", time: "3:30 PM" },
    ],
  },
  {
    id: "#CH-4518",
    status: "Completed",
    updated: "45 min ago",
    shop: "AutoFix Ltd",
    provider: "Rashid Ali",
    visits: 3,
    customer: { name: "Ali Hassan", phone: "+971 50 334 1290", email: "ali.hassan@mail.com", memberSince: "Jun 2024", subscribed: true },
    car: { vehicleType: "Truck", vehicleYear: 2020, vehicleMake: "Ford", vehicleModel: "Ranger", vehicleIdentificaionNumber: "MNCUMFF80LW987654", fuelType: "Diesel", currentOdometerReading: 101200, plateSource: "Dubai", plateCategory: "Commercial", plateCode: "K", plate: "90312" },
    service: {
      category: "Repair",
      options: [
        { label: "Issue", value: "Brake pads & discs" },
        { label: "Parts brand", value: "Brembo" },
        { label: "Axle", value: "Front" },
        { label: "Service type", value: "Visit shop" },
      ],
      preferredTime: "Today, 9:00 AM",
      notes: "Squeaking noise when braking.",
      estimate: "AED 640",
    },
    timeline: [
      { status: "Chat created", time: "Yesterday, 8:10 PM" },
      { status: "Accepted by provider", time: "Yesterday, 8:32 PM" },
      { status: "Marked completed", time: "Today, 1:15 PM" },
    ],
    chat: [
      { from: "system", text: "Booking request sent — chat is locked until the provider accepts.", time: "8:10 PM" },
      { from: "system", text: "AutoFix Ltd accepted the request. Chat unlocked.", time: "8:32 PM" },
      { from: "provider", text: "Hi Ali, bring it at 9 AM. Brembo pads are available.", time: "8:33 PM" },
      { from: "customer", text: "Thanks, will be there.", time: "8:40 PM" },
      { from: "system", text: "Provider marked this booking as completed.", time: "1:15 PM" },
    ],
  },
  {
    id: "#CH-4517",
    status: "Rejected",
    updated: "1 hr ago",
    shop: "Mike Auto Care",
    provider: "Mike Brown",
    visits: 1,
    rejectReason: "Battery model not in stock this week.",
    customer: { name: "Emma Wilson", phone: "+971 56 781 2203", email: "emma.w@mail.com", memberSince: "Aug 2026", subscribed: false },
    car: { vehicleType: "Crossover", vehicleYear: 2023, vehicleMake: "Kia", vehicleModel: "Sportage", vehicleIdentificaionNumber: "KNDPU3AF5P7112233", fuelType: "E-Plus 91", currentOdometerReading: 9800, plateSource: "Dubai", plateCategory: "Private", plateCode: "P", plate: "55120" },
    service: {
      category: "Battery",
      options: [
        { label: "Battery brand", value: "Varta" },
        { label: "Capacity", value: "70Ah AGM" },
        { label: "Service type", value: "Home service" },
      ],
      preferredTime: "Today, 2:00 PM",
      notes: "Car won't start.",
      estimate: "AED 450",
    },
    timeline: [
      { status: "Chat created", time: "Today, 12:05 PM" },
      { status: "Rejected by provider", time: "Today, 12:40 PM" },
    ],
    chat: [
      { from: "system", text: "Booking request sent — chat is locked until the provider accepts.", time: "12:05 PM" },
      { from: "system", text: "Mike Auto Care rejected the request: Battery model not in stock this week.", time: "12:40 PM" },
    ],
  },
  {
    id: "#CH-4516",
    status: "In Chat",
    updated: "2 hr ago",
    shop: "Speedy Motors",
    provider: "Ahmed Khan",
    visits: 8,
    customer: { name: "Bilal Ahmed", phone: "+971 58 220 4411", email: "bilal.a@mail.com", memberSince: "Feb 2024", subscribed: true },
    car: { vehicleType: "SUV", vehicleYear: 2022, vehicleMake: "Hyundai", vehicleModel: "Tucson", vehicleIdentificaionNumber: "KM8JBCAE4NU445566", fuelType: "Special 95", currentOdometerReading: 35600, plateSource: "Dubai", plateCategory: "Private", plateCode: "M", plate: "70834" },
    service: {
      category: "Oil Change",
      options: [
        { label: "Oil brand", value: "Castrol EDGE" },
        { label: "Oil grade", value: "0W-20 Full Synthetic" },
        { label: "Oil filter", value: "Replace (OEM)" },
        { label: "Service type", value: "Home service" },
      ],
      preferredTime: "Today, 7:00 PM",
      notes: "",
      estimate: "AED 210",
    },
    timeline: [
      { status: "Chat created", time: "Today, 11:30 AM" },
      { status: "Accepted by provider", time: "Today, 11:34 AM" },
    ],
    chat: [
      { from: "system", text: "Booking request sent — chat is locked until the provider accepts.", time: "11:30 AM" },
      { from: "system", text: "Speedy Motors accepted the request. Chat unlocked.", time: "11:34 AM" },
      { from: "provider", text: "Welcome back Bilal! Same address as last time?", time: "11:35 AM" },
      { from: "customer", text: "Yes, same villa.", time: "11:37 AM" },
    ],
  },
  {
    id: "#CH-4515",
    status: "Pending",
    updated: "3 hr ago",
    shop: "Sparkle Car Wash",
    provider: "Maria Lopez",
    visits: 1,
    customer: { name: "Nadia Rahman", phone: "+971 54 118 9002", email: "nadia.r@mail.com", memberSince: "Sep 2026", subscribed: false },
    car: { vehicleType: "Crossover", vehicleYear: 2021, vehicleMake: "Mazda", vehicleModel: "CX-5", vehicleIdentificaionNumber: "JM3KFBDM1M0778899", fuelType: "Special 95", currentOdometerReading: 51020, plateSource: "Ajman", plateCategory: "Private", plateCode: "B", plate: "11873" },
    service: {
      category: "Car Wash",
      options: [
        { label: "Package", value: "Exterior wash" },
        { label: "Service type", value: "Visit shop" },
      ],
      preferredTime: "Tomorrow, 11:00 AM",
      notes: "",
      estimate: "AED 40",
    },
    timeline: [{ status: "Chat created", time: "Today, 1:00 PM" }],
    chat: [
      { from: "system", text: "Booking request sent — chat is locked until the provider accepts.", time: "1:00 PM" },
    ],
  },
];

export const carLabel = (car) => `${car.vehicleMake} ${car.vehicleModel} ${car.vehicleYear}`;
export const plateLabel = (car) => [car.plateSource, car.plateCode, car.plate].filter(Boolean).join(" ");

export const pendingProviders = [
  { name: "QuickLube Express", owner: "Hamza Siddiqui", category: "Oil Change", submitted: "2h ago" },
  { name: "Desert Tyres", owner: "Yousef Malik", category: "Tyres", submitted: "5h ago" },
  { name: "Shine & Go", owner: "Priya Nair", category: "Car Wash", submitted: "1d ago" },
];

export const recentActivity = [
  { type: "subscription", text: "Sarah Khan subscribed to the Yearly plan (3rd vehicle added)", time: "5 min ago" },
  { type: "job", text: "Speedy Motors marked chat #CH-4521 as completed", time: "18 min ago" },
  { type: "shop", text: "New shop “Tyre Hub – Deira” created by Omar Farooq", time: "1 hr ago" },
  { type: "vehicle", text: "142 new vehicles registered today", time: "2 hr ago" },
  { type: "suspend", text: "User John Smith account suspended", time: "3 hr ago" },
  { type: "flag", text: "Post flagged in Community", time: "5 hr ago" },
];
